import { useFormik } from "formik"
import React, { useEffect, useState } from "react"
import { Button, Col, FloatingLabel, Form, Row, Spinner } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import * as Yup from "yup"
import CustomSelect from "../../../components/CustomSelect"
import ModalComponent from "../../../components/Modal"
import TooltipComponent from "../../../components/Tooltip"
import { admin } from "../../../config/apiEndpoints"
import axiosProvider from "../../../lib/AxiosProvider"
import {
  generateRandomPassword,
  handleOnBlur,
  handleOnchange,
} from "../../../lib/GlobalMethods"
import {
  _alphabetRegex_,
  _emailRegex_,
  _mobileNumberRegex_,
} from "../../../lib/Regex"

const AddEditUser = ({
  isUpdate,
  setIsUpdate,
  show,
  fetchData,
  setData,
  handleClose,
}) => {
  const [roleData, setRoleData] = useState([])
  const [allStationDetails, setAllStationDetails] = useState([])
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const togglePasswordVisibility = () => setShowPassword(!showPassword)

  const validationSchema = Yup.object({
    firstname: Yup.string()
      .min(2, "Enter at least 2 characters for First Name")
      .required("First Name is required"),
    lastname: Yup.string()
      .min(2, "Enter at least 2 characters for Last Name")
      .required("Last Name is required"),
    email: Yup.string().when("update", {
      is: false,
      then: () =>
        Yup.string()
          .email("Please enter valid email Id")
          .matches(_emailRegex_, "Enter correct Email")
          .required("Email is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    password: Yup.string().when("update", {
      is: false,
      then: () =>
        Yup.string()
          .required("Password is Required!")
          .min(6, "Password should be 6 chars minimum.")
          .max(16, "Password should be 16 chars maximum.")
          .matches(/[a-zA-Z]/, "Password should contain at least one letter")
          .matches(/[^\w]/, "Password requires a symbol"),
      otherwise: () => Yup.string().notRequired(),
    }),
    roleId: Yup.object().required("User type is required"),
    // station_ids:
    //   isUpdate?.data_scope === "OWN"
    //     ? Yup.array().of(Yup.string()).min(1, "Station Name is Required")
    //     : Yup.array().notRequired(),
    phone: Yup.string().when("update", {
      is: false,
      then: () =>
        Yup.string()
          .min(10, "Please Enter Valid Mobile Number")
          .required("Mobile Number is Required"),
      otherwise: () => Yup.string().notRequired(),
    }),
  })

  const handleSubmit = async (values, { resetForm, setFieldError }) => {
    try {
      if (
        values?.roleId?.data_scope === "OWN" &&
        values?.station_ids?.length <= 0
      ) {
        setFieldError("station_ids", "Station Name is Requried")
        return
      }

      setLoading(true)
      values = {
        ...values,
        roleId: values?.roleId?.value,
        station_ids:
          //values?.station_ids?.[0] !== null || values?.station_ids?.length > 0
          values?.station_ids?.length > 0 ? values.station_ids : undefined,
      }
      let requestData = {
        ...values,
        station_ids:
          // values?.station_ids?.[0] !== null || values?.station_ids?.length > 0
          values?.station_ids?.length > 0 ? values.station_ids : undefined,
      }
      if (isUpdate) {
        const { email, phone, ...rest } = requestData
        requestData = rest
      }

      const response = await axiosProvider({
        method: isUpdate ? "PATCH" : "POST",
        endpoint: isUpdate
          ? admin.updateAdminUser + values.id
          : admin.createAdminUser,
        data: isUpdate ? requestData : values,
      })
      if (response?.data?.code === 201 || response?.data?.code === 200) {
        toast.success(response.data.message)
        setLoading(false)

        isUpdate
          ? setData((prevData) =>
              prevData.map((item) =>
                item.id === values.id
                  ? {
                      ...item,
                      ...response.data.data,
                    }
                  : item,
              ),
            )
          : fetchData("")
        handleClose()
        setIsUpdate(false)
        resetForm()
      } else {
        setLoading(false)
        throw { message: response?.data?.message }
      }
    } catch (error) {
      setLoading(false)
      toast.error(error.message)
    }
  }

  const formik = useFormik({
    initialValues: isUpdate
      ? {
          id: isUpdate.id,
          firstname: isUpdate.firstname,
          lastname: isUpdate.lastname,
          roleId: roleData.find((role) => role.label === isUpdate.role),
          // roleId: roleData.find(
          //   (role) => role.label === isUpdate.admin_role.role,
          // ),
          email: isUpdate.email,
          phone: isUpdate.phone,
          station_ids: [isUpdate?.station_ids?.[0]],
        }
      : {
          update: false,
          firstname: "",
          lastname: "",
          email: "",
          roleId: null,
          password: "",
          phone: "",
          station_ids: [],
        },
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  })

  const { errors, values, touched, setFieldValue, resetForm } = formik

  const handleGeneratePassword = () => {
    const generatedPassword = generateRandomPassword(10)

    formik.setFieldValue("password", generatedPassword)
  }

  const fetchRoleData = async () => {
    try {
      const response = await axiosProvider({
        method: "GET",
        endpoint: admin.rolesList,
      })

      const data = response?.data?.data?.map(({ id, role, data_scope }) => ({
        value: id,
        label: role,
        data_scope,
      }))
      setRoleData(data)
    } catch (error) {
      toast.error(error?.message)
    }
  }

  const getAllStationDetails = async () => {
    try {
      const respone = await axiosProvider({
        method: "GET",
        endpoint: `${admin.chargingStationList}`,
      })

      if (respone?.data?.code === 200) {
        const formattedData = respone?.data?.data?.map((items) => ({
          label: items?.station_name,
          value: items?.id,
        }))

        setAllStationDetails(formattedData)
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchRoleData()
    getAllStationDetails()
  }, [])

  return (
    <>
      <ModalComponent
        show={show}
        modalsize={"md"}
        backdrop="static"
        animationFade={true}
        onHide={() => {
          handleClose()
          resetForm()
        }}
        loading={loading}
        modeltitle={isUpdate ? "Update User" : "Create User"}
        submitname={
          loading ? (
            <Spinner size="sm" animation="border" variant="dark" />
          ) : isUpdate ? (
            "Update"
          ) : (
            "Add"
          )
        }
        btnclosetext="Cancel"
        handleSubmit={formik.handleSubmit}
        children={
          <Form noValidate>
            <Row xs={"auto"}>
              <Col xs={6}>
                <FloatingLabel
                  controlId="nameAdmin"
                  label={
                    <>
                      First Name <span className="required_star">*</span>
                    </>
                  }
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="firstname"
                    autoComplete="false"
                    maxLength={20}
                    value={values.firstname}
                    onChange={(e) => handleOnchange(e, _alphabetRegex_, formik)}
                    onBlur={(e) => handleOnBlur(e, formik)}
                    isInvalid={touched.firstname && errors.firstname}
                    isValid={touched.firstname && !errors.firstname}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.firstname}
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Col>
              <Col xs={6}>
                <FloatingLabel
                  controlId="nameAdmin"
                  label={
                    <>
                      Last Name <span className="required_star">*</span>
                    </>
                  }
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="lastname"
                    autoComplete="false"
                    maxLength={20}
                    value={values.lastname}
                    onChange={(e) => handleOnchange(e, _alphabetRegex_, formik)}
                    onBlur={(e) => handleOnBlur(e, formik)}
                    isInvalid={touched.lastname && errors.lastname}
                    isValid={touched.lastname && !errors.lastname}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.lastname}
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Col>
              <Col xs={12}>
                <FloatingLabel
                  controlId="emailAdmin"
                  label={
                    <>
                      Email <span className="required_star">*</span>
                    </>
                  }
                  className="mb-3"
                >
                  <Form.Control
                    autoComplete="false"
                    type="email"
                    name="email"
                    disabled={isUpdate ? true : false}
                    placeholder=""
                    className="mb-n1"
                    value={values.email}
                    onChange={(e) => handleOnchange(e, false, formik)}
                    onBlur={(e) => handleOnBlur(e, formik)}
                    isInvalid={touched.email && errors.email}
                    isValid={touched.email && !errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Col>

              <Col xs={12}>
                <FloatingLabel
                  controlId="emailAdmin"
                  label={
                    <>
                      Phone Number <span className="required_star">*</span>
                    </>
                  }
                  className="mb-3"
                >
                  <Form.Control
                    autoComplete="false"
                    type="text"
                    name="phone"
                    disabled={isUpdate ? true : false}
                    placeholder=""
                    className="mb-n1"
                    maxLength={10}
                    value={values.phone}
                    onChange={(e) =>
                      handleOnchange(e, _mobileNumberRegex_, formik)
                    }
                    onBlur={(e) => handleOnBlur(e, formik)}
                    isInvalid={touched.phone && !!errors.phone}
                    isValid={touched.phone && !errors.phone}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.phone}
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Col>
              <Col xs={12} className="custom_selectinvalid_bdr mb-3">
                <label>
                  User Type<span className="required_star">*</span>
                </label>

                <CustomSelect
                  value={values?.roleId}
                  handleSelectChange={(selectedOption) => {
                    setFieldValue("roleId", selectedOption)
                  }}
                  options={roleData}
                  isMulti={false}
                  placeholder={"Select User Type"}
                />

                {touched?.roleId && errors?.roleId && (
                  <p className="invalid_error">{errors.roleId}</p>
                )}
              </Col>
              <Col xs={12} className="custom_selectinvalid_bdr mb-3">
                <label>
                  Station Name<span className="required_star">*</span>
                </label>

                <CustomSelect
                  value={allStationDetails?.find(
                    (option) => option?.value === values?.station_ids?.[0],
                  )}
                  handleSelectChange={(selectedStationId) => {
                    setFieldValue(
                      "station_ids",
                      selectedStationId?.value
                        ? [selectedStationId?.value]
                        : [],
                    )
                  }}
                  options={allStationDetails}
                  isMulti={false}
                  placeholder={"Select Station Name"}
                />

                {touched?.station_ids && errors?.station_ids && (
                  <p className="invalid_error">{errors.station_ids}</p>
                )}
              </Col>

              {isUpdate ? (
                ""
              ) : (
                <Col xs={12} className="mb-3">
                  <div className="d-flex gap-3 align-items-start">
                    <FloatingLabel
                      controlId="passwordAdmin"
                      label={
                        <>
                          Password <span className="required_star">*</span>
                        </>
                      }
                      className="position-relative passwordicon_wrapper w-100"
                    >
                      <Form.Control
                        disabled
                        type={showPassword ? "text" : "password"}
                        placeholder=""
                        autoComplete="false"
                        name="password"
                        value={values.password}
                        onChange={(e) => handleOnchange(e, false, formik)}
                        onBlur={(e) => handleOnBlur(e, formik)}
                        isInvalid={touched.password && errors.password}
                      />
                      <i
                        className={`icon_main ${
                          showPassword ? "eye_close" : "eye_open"
                        } `}
                        onClick={togglePasswordVisibility}
                      ></i>
                      <Form.Control.Feedback type="invalid">
                        {errors?.password}
                      </Form.Control.Feedback>
                    </FloatingLabel>

                    <TooltipComponent
                      toolplace="top"
                      tooltipText="Generate password"
                    >
                      <Button
                        variant="outline-primary"
                        className="btn btn-outline-primary d-inline-flex flex-shrink-0 px-2 py-2"
                        onClick={handleGeneratePassword}
                      >
                        <i className="icon_main clock_wise"></i>
                      </Button>
                    </TooltipComponent>
                  </div>
                </Col>
              )}
            </Row>
          </Form>
        }
      />
    </>
  )
}

export default AddEditUser
